import 'css-chunksrc/client/scenes/documentUpload/fileInput/styles.scss';export default {
  "fileInput": "_fileInput_pjq7r_1",
  "placeholder": "_placeholder_pjq7r_10",
  "input": "_input_pjq7r_16"
};